import classNames from 'classnames';
import React, { useState } from 'react';
import Modal from 'react-modal';

import CloseIcon from '../../assets/svg/close-dark.inline.svg';
import { IterableForm } from '../iterableForm';
import { PortableText } from '../portableText';
import * as styles from './iterable-popup.module.css';

export function IterablePopup({
	iterableForm,
	iterablePopupOpen,
	setIterablePopupOpen,
}) {
	// state
	const [formSubmitted, setFormSubmitted] = useState(false);

	const modalStyles = {
		content: {
			top: '50%',
			left: '50%',
			right: 'auto',
			bottom: 'auto',
			transform: 'translate(-50%, -44%)',
			backgroundColor: '#f1f3ef',
			padding: 'var(--stack-card-padding-md)',
			maxWidth: '600px',
			maxHeight: '84vh',
			width: 'calc(100% - 32px)',
		},
		overlay: {
			zIndex: 1,
			backgroundColor: 'rgba(0, 0, 0, 0.20)',
		},
	};

	const {
		_rawDisclaimer,
		eyebrowText,
		eyebrowTextOverride,
		headerText,
		headerTextOverride,
		subheaderText,
		subheaderTextOverride,
		thankYouMessage,
	} = iterableForm;

	return (
		<Modal
			ariaHideApp={false}
			contentLabel='Get Started'
			isOpen={iterablePopupOpen}
			onRequestClose={() => setIterablePopupOpen(false)}
			style={modalStyles}
			htmlOpenClassName='ReactModal__Html--open'
		>
			<button
				className={styles.closeButton}
				onClick={() => setIterablePopupOpen(false)}
			>
				<CloseIcon />
			</button>
			{formSubmitted && thankYouMessage && (
				<div className={styles.thankYouContainer}>
					<PortableText blocks={thankYouMessage} />
				</div>
			)}
			{!formSubmitted && (
				<div className={styles.iterableContainer}>
					<div className={styles.headerContainer}>
						{(eyebrowTextOverride || eyebrowText) && (
							<p className={styles.eyebrowText}>
								{eyebrowTextOverride || eyebrowText}
							</p>
						)}
						{(headerTextOverride || headerText) && (
							<h2 className='body-display'>
								{headerTextOverride || headerText}
							</h2>
						)}
						{(subheaderTextOverride || subheaderText) && (
							<p className={styles.descriptionText}>
								{subheaderTextOverride || subheaderText}
							</p>
						)}
					</div>
					<IterableForm
						className='twocol'
						iterableForm={iterableForm}
						setFormSubmitted={setFormSubmitted}
					/>
					{_rawDisclaimer && (
						<PortableText
							blocks={_rawDisclaimer}
							className={classNames(
								styles.disclaimerContainer,
								'body-xs'
							)}
						/>
					)}
				</div>
			)}
		</Modal>
	);
}
